/**
 * Generate marker from space data
 * @param {Object} space - Space object
 * @param {number} index - Space index
 * @returns {Object} Marker object
 */
export const generateMarkerFromSpace = (space, index) => {
  const actualState = space.senses?.availability?.state;
  let status = 'available';
  let color = '#28a745';

  // Map actual state values to display states
  switch(actualState) {
    case 0: // ABSENCE
    case 2: // AVAILABLE
    case 5: // CHECKOUT
      status = 'available';
      color = '#28a745';
      break;
    case 1: // PRESENCE
      status = 'occupied';
      color = '#dc3545';
      break;
    case 3: // ALLOCATED
      status = 'reserved';
      color = '#007bff';
      break;
    case 4: // CHECKIN
      status = 'occupied';
      color = '#fd7e14'; // Orange for checked-in
      break;
    default:
      status = 'available';
      color = '#6c757d';
  }

  return {
    id: String(space.id),
    name: space.name || `Space ${space.id}`,
    x: space.srf.x,
    y: space.srf.y,
    size: 100,
    status: status,
    color: color,
    timestamp: space.senses?.availability?.timestamp || Date.now(),
    rawState: actualState
  };
};

/**
 * Filter spaces for desk category with SRF data
 * @param {Array} spaces - Array of space objects
 * @returns {Array} Filtered spaces
 */
export const filterDeskSpaces = (spaces) => {
  return spaces?.filter(space => space.srf && space.category?.name === "Desk") || [];
};

/**
 * Generate markers from filtered spaces
 * @param {Array} filteredSpaces - Filtered spaces array
 * @returns {Array} Array of marker objects
 */
export const generateMarkersFromSpaces = (filteredSpaces) => {
  if (!filteredSpaces.length) return [];
  
  return filteredSpaces.map(generateMarkerFromSpace);
};
